import React from 'react';
import validator from 'validator';
import cardValidator from 'card-validator';
import CommonPasswords from './CommonPasswords';

// rename exports so they become cleaner imports
export { default as Form } from 'react-validation/build/form';
export { default as Input } from 'react-validation/build/input';
export { default as Select } from 'react-validation/build/select';

let securityCodeLength;
let testMode = false;

export const Rules = {
  // Key name maps the rule
  required: (value) => {
    let formattedValue = '';
    if (value) {
      formattedValue = value.toString().trim();
    }

    if (formattedValue) {
      return undefined;
    }
    return <span className="form-error is-visible">This field is required.</span>;
  },

  minPasswordLength: (value) => {
    let formattedValue = '';
    if (value) {
      formattedValue = value.toString().trim();
    }

    if (formattedValue.length >= 8) {
      return undefined;
    }
    return (
      <span className="form-error is-visible">
        Your password must be 8 characters or longer.
      </span>
    );
  },

  strongPassword: (value) => {
    let formattedValue = '';
    if (value) {
      formattedValue = value.toString().trim();
    }

    if (CommonPasswords.indexOf(formattedValue) < 0) {
      return undefined;
    }

    return (
      <span className="form-error is-visible">
        Passwords cannot be easily guessed
        common phrases like &quot;password&quot;, keyboard
        patterns such as &quot;qwerty&quot;, or sequences such
        as &quot;1234&quot;.
      </span>
    );
  },

  email: (value) => {
    let formattedValue = '';
    if (value) {
      formattedValue = validator.isEmail(value);
    }

    if (formattedValue) {
      return undefined;
    }
    return <span className="form-error is-visible">{value} is not a valid email address.</span>;
  },

  validTestCreditCard: (value) => {
    let isValid;
    if (value === '1' || value === '2' || value === '3') {
      // whitelist Chargify's test numbers if in 'test purchase' mode
      isValid = true;
      testMode = true;
    }

    if (isValid) {
      return undefined;
    }
    return (
      <span className="form-error is-visible">{value} is not a valid credit card number.</span>
    );
  },

  validCreditCard: (isTestPurchase, value) => {
    let isValid;
    if (value) {
      const validationInfo = cardValidator.number(value);
      isValid = validationInfo.isValid;
      if (isValid) {
        securityCodeLength = validationInfo.card.code.size;
      } else if (isTestPurchase) {
        return Rules.validTestCreditCard(value);
      }
    }

    if (isValid) {
      return undefined;
    }
    return (
      <span className="form-error is-visible">{value} is not a valid credit card number.</span>
    );
  },

  creditCard: (value) => {
    let isTestPurchase = false;
    // window.$_GET is not set on SmartResumeWizard and SmartCoverLetter
    if (Object.keys(window.$_GET).length) {
      isTestPurchase = !!window.$_GET.test_purchase;
    } else {
      isTestPurchase = window.location.search.indexOf('test_purchase') > -1;
    }

    return Rules.validCreditCard(isTestPurchase, value);
  },

  noAmEx: (value) => {
    let isAmex = false;
    if (value && !testMode) {
      const validationInfo = cardValidator.number(value);
      isAmex = validationInfo.card.isAmex;
    }
    if (isAmex) {
      return (
        <span className="form-error is-visible">
          Sorry, we do not accept AMERICAN EXPRESS, please try another credit card.
        </span>
      );
    }
    return undefined;
  },

  cvv: (value) => {
    let isValid;
    if (value) {
      let validationInfo;
      if (securityCodeLength <= 3) {
        validationInfo = cardValidator.cvv(value);
      } else {
        // set cvv number length to 4 if AMEX
        validationInfo = cardValidator.cvv(value, 4);
      }

      if (!testMode) {
        isValid = validationInfo.isValid;
      } else {
        isValid = testMode;
      }
    }

    if (isValid) {
      return undefined;
    }
    return <span className="form-error is-visible">{value} is not a valid CVV number.</span>;
  },

  ccExpiration: (value, props, components) => {
    if (!components) {
      return undefined;
    }
    let isValid = false;
    const ccExpirationMonth = components['signup[payment_profile][expiration_month]'][0].value;
    if (value) {
      const expirationDate = { month: ccExpirationMonth, year: value };
      const ccExpirationValidationInfo = cardValidator.expirationDate(expirationDate);
      isValid = ccExpirationValidationInfo.isValid;
    }

    if (isValid) {
      return undefined;
    }

    return <span className="form-error is-visible">Please enter a valid expiration.</span>;
  },

  passwordConfirm: (value, props, components) => {
    let isValid = false;
    if (value) {
      const password = components.password[0].value;
      if (value === password) {
        isValid = true;
      }
    }

    if (isValid) {
      return undefined;
    }
    return <span className="form-error is-visible">Your passwords do not match.</span>;
  },

  emailConfirm: (value, props, components) => {
    let isValid = false;
    if (value) {
      const email = components['signup[customer][email]'][0].value;
      if (value === email) {
        isValid = true;
      }
    }

    if (isValid) {
      return undefined;
    }
    return <span className="form-error is-visible">Please make sure email fields match.</span>;
  },
};



// WEBPACK FOOTER //
// ./src-react/Validation/index.jsx